import { Button } from '@/components/shared/button/Button';
import { TSTitleCard } from '@/components/shared/card/Card';
import { Icon } from '@/components/shared/icons/Icon';
import { dateToApiFormat } from '@/helpers/dateHelper';
import { FC } from 'react';
import { FiAlertTriangle, FiCalendar, FiCheck } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { useRosterPeriodDetails } from './useRosterPeriodDetails';

export const FutureRosters: FC = () => {
  const { displayString, titleString, displayCheck, dates, warning } = useRosterPeriodDetails();
  const navigate = useNavigate();

  return (
    <TSTitleCard
      title={titleString}
      icon={FiCalendar}
      smallContent={
        <Button onClick={() => navigate(`/rosters/calendar/${dateToApiFormat(dates[0])}`)}>View Calendar</Button>
      }
      theme={warning ? 'amber' : 'primary'}
    >
      <div className="flex py-3 px-4 items-center">
        <span className="flex-1">{displayString}</span>
        {displayCheck && <Icon Icon={FiCheck} theme={'primary'}></Icon>}
        {warning && <Icon Icon={FiAlertTriangle} theme={'amber'}></Icon>}
      </div>
    </TSTitleCard>
  );
};
